"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 w-full">
        {Array.from({
        length: 4
      }).map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted/10 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-4">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-sans text-base text-muted hover:text-primary-foreground transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const TickerContent = () => <div className="flex whitespace-nowrap">
    {Array.from({
    length: 10
  }).map((_, i) => <span key={i} data-index={i} className="mx-4">
        COMFORT • RELIABILITY • CLEANLINESS
      </span>)}
  </div>;
export default function Footer() {
  return <section id="footer" className="bg-primary text-muted border-t border-muted-foreground/30 overflow-hidden relative">
      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-ticker {
          animation: ticker 40s linear infinite;
        }
      `}</style>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto">
        {}
        <div className="flex flex-col items-start">
          <Link to="/" className="inline-block transition-transform duration-500 hover:scale-105">
            <WvcLogo className="h-8 w-auto text-primary-foreground" />
          </Link>
        </div>

        {}
        <div className="flex flex-col items-start">
          <h3 className="font-mono text-[0.75rem] font-semibold tracking-[0.15em] uppercase text-muted-foreground mb-6">
            Navigation
          </h3>
          <MenuProvider menu_id="17">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="flex flex-col items-start">
          <h3 className="font-mono text-[0.75rem] font-semibold tracking-[0.15em] uppercase text-muted-foreground mb-6">
            Legal
          </h3>
          <p className="font-sans text-base text-muted">
            Company registration 16176189
          </p>
        </div>

        {}
        <div className="flex flex-col items-start">
          <h3 className="font-mono text-[0.75rem] font-semibold tracking-[0.15em] uppercase text-muted-foreground mb-6">
            Contact
          </h3>
          <p className="font-sans text-base text-muted">
            07956675231
          </p>
        </div>
      </div>

      {}
      <div className="text-center pb-12 font-mono text-[10px] text-muted-foreground uppercase tracking-widest">
        praisespaces.com
      </div>

      {}
      <div className="w-full overflow-hidden border-t border-muted-foreground/20 py-3 bg-primary">
        <div className="flex w-max animate-ticker font-mono text-[10px] text-muted tracking-widest">
          <TickerContent />
          <TickerContent />
        </div>
      </div>
    </section>;
}